<template>
    <DsTable :is-scrollable="true" :is-responsive="true">
        <DsTableRow>
            <DsTableCell type="th">Uhodnutá čísla</DsTableCell>
            <DsTableCell type="th">Vklad</DsTableCell>
            <DsTableCell type="th">Sudá / Lichá</DsTableCell>
            <DsTableCell type="th">Vklad</DsTableCell>
            <DsTableCell type="th">Nízká / Vysoká</DsTableCell>
            <DsTableCell type="th">Vklad</DsTableCell>

            <DsTableCell type="th">Výhra</DsTableCell>
        </DsTableRow>
        <DsTableRow v-if="boardResult">
            <DsTableCell>{{ formatMatchingNumbers(boardResult) }}</DsTableCell>
            <DsTableCell><span v-html="formatNumberWithCurrency(getStake(0))"></span></DsTableCell>
            <DsTableCell>{{ getSubGameText(Rychla6BetType.EvenOdd, boardResult.matchingEvenOdd) }}</DsTableCell>
            <DsTableCell><span v-html="formatNumberWithCurrency(getStake(1))"></span></DsTableCell>
            <DsTableCell>{{ getSubGameText(Rychla6BetType.LowHigh, boardResult.matchingLowHigh) }}</DsTableCell>
            <DsTableCell><span v-html="formatNumberWithCurrency(getStake(2))"></span></DsTableCell>
            <DsTableCell><span v-html="formatNumberWithCurrency(boardResult.winAmount)"></span></DsTableCell>
        </DsTableRow>
    </DsTable>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsTableRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsTableCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { TicketCheckResultsBoard } from "@/lotteries/model/ticket-check/ticket-check";
import { StringUtils } from "@sazka/utils/string-utils";
import { useWagerBoardStore } from "../../stores/use-wager-board-store";
import { Rychla6BetEvenOdd, Rychla6BetLowHigh, Rychla6BetType } from "@sazka/lotteries/js/models/rychla-6-bet-type";

const props = defineProps<{
    lottery: Lottery;
    results: TicketCheckResultsBoard[];
}>();
const EMPTY_CELL_STRING = "–––";

const boardResult = computed(() => props.results[0]);

const wagerStore = useWagerBoardStore();

const rychla6EvenOddTexts = {
    [Rychla6BetEvenOdd.Even]: "Sudá",
    [Rychla6BetEvenOdd.Equal]: "Stejně",
    [Rychla6BetEvenOdd.Odd]: "Lichá",
};

const rychla6HighLowTexts = {
    [Rychla6BetLowHigh.Low]: "Nízká",
    [Rychla6BetLowHigh.Equal]: "Stejně",
    [Rychla6BetLowHigh.High]: "Vysoká",
};

const getSubGameText = (subGameType: Rychla6BetType, subGameValue: Rychla6BetEvenOdd | Rychla6BetLowHigh) => {
    if (subGameType === Rychla6BetType.EvenOdd) {
        return rychla6EvenOddTexts[subGameValue] || EMPTY_CELL_STRING;
    }

    return rychla6HighLowTexts[subGameValue] || EMPTY_CELL_STRING;
};

const getStake = (boardIndex: number) => {
    const board = wagerStore.boards[boardIndex];

    if (!board.primary?.length) {
        return 0;
    }

    return wagerStore.boards[boardIndex]?.stake;
};

const formatNumberWithCurrency = (amount: number) => {
    if (amount) {
        return StringUtils.formatCurrency(amount);
    }

    return EMPTY_CELL_STRING;
};

const formatMatchingNumbers = (board: TicketCheckResultsBoard) => {
    const formattedPrimary = board.matchingPrimary?.join(", ");

    return formattedPrimary || EMPTY_CELL_STRING;
};
</script>
